import { gsap } from 'gsap';

import Signal from '../../assets/scripts/classes/Signal';
import Scroll from '../../assets/scripts/helpers/Scroll';

const HTML_CLASSLIST = document.documentElement.classList;
const ClassName = {
	NO_SCROLL: '_no-scroll',
};

class Popups {
	constructor() {
		this.init();
	}

	init() {
		this.wrapper = document.querySelector('[data-popups]');
		this.inner = document.querySelector('.popups__popup');

		if (!this.wrapper) {
			return;
		}

		this.onOpen = new Signal();
		this.onClose = new Signal();
		this.onCloseStart = new Signal();

		this.opened = false;
		this.openedClass = '';

		this.activePopup = null;
		this.activePopupName = '';
		this.popups = document.querySelectorAll('[data-popup]');

		Array.from(document.querySelectorAll('[data-popup-opener]')).forEach(
			(element) => {
				element.addEventListener('click', (e) => {
					e.preventDefault();

					this.open(
						e.currentTarget.getAttribute('data-popup-opener'),
						e.currentTarget,
					);
				});
			},
		);

		Array.from(document.querySelectorAll('[data-popup-closer]')).forEach(
			(element) => {
				element.addEventListener('click', (e) => {
					e.preventDefault();

					this.close();
				});
			},
		);

		window.addEventListener('keydown', (e) => {
			if (this.opened && e.key === 'Escape') {
				this.close();
			}
		});

		this.wrapper.addEventListener('click', (e) => {
			if (this.opened) {
				if (
					e.target === this.wrapper ||
					e.target === this.inner ||
					e.target.classList.contains('popups__popup')
				) {
					this.close();
				}
			}
		});
	}
	open(name, element = false) {
		if (this.activePopupName === name) {
			return;
		}

		if (this.opened) {
			this.close(true);
		}

		const popup = this.wrapper.querySelector('[data-popup="' + name + '"]');

		if (!popup) {
			return;
		}

		if (element) {
			const formTitle = element.dataset.formTitle;
			const formType = element.dataset.formType;
			const formData = element.dataset.formData || '';
			const popupTitle = popup.querySelector('.popups-title');
			const popupType = popup.querySelector('[name="type"]');
			const popupData = popup.querySelector('[name="data"]');
			if (popupTitle && formTitle) popupTitle.innerText = formTitle;
			if (popupType && formType) popupType.value = formType;
			if (popupData) popupData.value = formData;
		}

		this.opened = true;
		this.activePopup = popup;
		this.activePopupName = name;
		this.popupOpenAnimation = this.activePopup.getAttribute(
			'data-popup-open-animation',
		);

		this.wrapper.classList.add('_' + name);

		this.wrapper.classList.remove('no-pe');

		gsap.to(this.wrapper, {
			duration: 0.35,
			autoAlpha: 1,
			overwrite: true,
			display: 'flex',
		});

		gsap.fromTo(
			this.activePopup,
			{ autoAlpha: 0, scale: 0.98, display: 'flex' },
			{
				duration: 0.35,
				autoAlpha: 1,
				scale: 1,
			},
		);

		Scroll.disabled(this.wrapper);
		HTML_CLASSLIST.add(ClassName.NO_SCROLL);

		HTML_CLASSLIST.add('_popup-opened');

		this.openedClass = '_popup-opened-' + name;
		HTML_CLASSLIST.add(this.openedClass);

		this.onOpen.call();
	}
	close(immediate = false) {
		if (this.opened) {
			this.opened = false;

			this.wrapper.classList.remove('_' + this.activePopupName);

			this.onCloseStart.call(this.activePopupName);
			this.popupCloseAnimation = this.activePopup.getAttribute(
				'data-popup-close-animation',
			);

			this.activePopupName = '';

			this.wrapper.classList.add('no-pe');
			gsap.to(this.wrapper, 0.35, {
				duration: 0.35,
				autoAlpha: 0,
				display: 'none',
			});

			Scroll.enabled(this.wrapper);

			HTML_CLASSLIST.remove(ClassName.NO_SCROLL);

			gsap.to(this.activePopup, {
				duration: immediate ? 0 : 0.35,
				autoAlpha: 0,
				scale: 0.98,
				display: 'none',
			});

			HTML_CLASSLIST.remove('_popup-opened');

			if (this.openedClass !== '') {
				HTML_CLASSLIST.remove(this.openedClass);
				this.openedClass = '';
			}
		}
	}
	getPopup(name) {
		return this.wrapper.querySelector('[data-popup="' + name + '"]');
	}
}

export default new Popups();
